export default __webpack_public_path__ + "img/69b8ee1338ac296086d19d18bd5c5c21.png";